import { LabelVariant } from '@workwhile/ui'

// Computed by the backend. "Stuck" (alerted, not yet overdue) is a
// reportDeadlineAt reading, not its own status; "missed" (overdue) is.
export const JET_CALL_REPORT_STATUS_VALUES = [
  'scheduled',
  'in_progress',
  'pending',
  'missed',
  'admin_review',
  'synced',
  'excluded',
] as const

export type JetCallReportStatus = (typeof JET_CALL_REPORT_STATUS_VALUES)[number]

export const JET_CALL_REPORT_STATUS_LABELS: Record<
  JetCallReportStatus,
  string
> = {
  scheduled: 'Scheduled',
  in_progress: 'Started',
  pending: 'Pending',
  missed: 'Missed',
  admin_review: 'Admin Review',
  synced: 'Synced',
  excluded: 'Excluded',
}

export const JET_CALL_REPORT_STATUS_LABEL_VARIANTS: Record<
  JetCallReportStatus,
  LabelVariant
> = {
  scheduled: 'neutral',
  in_progress: 'neutral',
  pending: 'neutral',
  missed: 'error',
  admin_review: 'warning',
  synced: 'success',
  excluded: 'error',
}

export const JET_CALL_REPORT_STATUS_OPTIONS: {
  value: JetCallReportStatus
  label: string
}[] = JET_CALL_REPORT_STATUS_VALUES.map((value) => ({
  value,
  label: JET_CALL_REPORT_STATUS_LABELS[value],
}))
